import ParameterErrors from '../../errors/ParameterErrors';
const { throwNotProvided } = ParameterErrors;
const OBJECT_ID_JSON_KEY='o';
const REASONS_JSON_KEY='r';
export default class ReasonsHelper {
	constructor({objectId, reason}){
		this._objectId = objectId; 
		this._reasons = reason;
	}
	get objectId(){
		return this._objectId;
	}
	get reasons(){
		return this._reasons;
	}
	static getDescription(reason){
		switch(reason){
			case 1:
				return 'AnyVertexOfObjectInsideQuadrant';
			case 2:
				return 'AnyQuadPointInsideObject';
			case 3:
				return 'ObjectWithinSmallEnoughDistance';
			case 4:
				return 'GameObjectVisibleWithinFieldOfView';
			default:
				return 'unknown reason with value'+reason;
		}
	}
}